import React from "react";
import myRestClient from "../common/restClient";
import { Field } from "redux-form";
import * as aor from "react-admin";
import AutoCompleteInput from "../components/AutoCompleteInput";
import restClient from "../common/restClient";
import { POLICY_TICKETS } from "../common/rolesManagement";
import { getPolicies, getUserCompany } from "../common/authClient";

const company_id = getUserCompany();

const customerOptions = {
    resource: "customers",
    display: "name",
    label: "Cliente",
    isMulti: false
};

const companyOptions = {
    resource: "companies",
    display: "name",
    label: "Azienda",
    isMulti: false
};

class TicketCreate extends React.Component {
    state = {
        company: null,
        loginCompanyName: null,
        customerSelectDisabled: true,
        company_licenses: [],
        activitySelectDisabled: true,
        instTypeSelectDisabled: true,
        activity_types: [],
        inst_types: []
    };

    componentDidMount() {
        myRestClient("GET_ONE", "companies", {
            id: company_id
        }).then(
            result => {
                this.setState({
                    loginCompanyName: result.data.name
                });
            },
            error => {
                console.log(error);
            }
        );
        const params = {
            filter: this.props.filter,
            pagination: { page: 1, perPage: 10000 },
            sort: { field: "id", order: "asc" }
        };
        restClient("GET_LIST", "installation_types", params).then(
            result => {
                const data = result.data.map(item => {
                    return {
                        id: item.id,
                        name: item.name,
                        licenses: item.licenses,
                        max_pdl: item.max_pdl
                    };
                });
                this.setState({ inst_types: data });
            },
            error => {
                console.log(error);
            }
        );
    }

    getOptLic = company_licenses => {
        if (company_licenses) {
            return company_licenses
                .filter(license =>
                    this.state.inst_types.some(
                        inst_type => inst_type.id === license
                    )
                )
                .map(license => {
                    const inst_type = this.state.inst_types.find(
                        inst_type => inst_type.id === license
                    );
                    return {
                        id: inst_type.id,
                        name: inst_type.name
                    };
                });
        }
        return [];
    };

    getOptTypes = id_inst_type => {
        if (id_inst_type) {
            const params = {
                pagination: { page: 1, perPage: 10000 },
                sort: { field: "name", order: "asc" },
                filter: { installation_type_id: id_inst_type },
                filter_type: ["INSTALLATION", "MIGRATION"]
            };
            restClient("GET_LIST", "operations", params).then(
                result => {
                    const data = result.data.map(item => {
                        return {
                            id: item.operation_type_name,
                            name: item.operation_type_description
                        };
                    });
                    this.setState({
                        activity_types: data,
                        activitySelectDisabled: false
                    });
                },
                error => {
                    return error;
                }
            );
        }
    };

    setCompanyValue = value => {
        this.setState({
            company: value.label,
            customerSelectDisabled: false,
            instTypeSelectDisabled: false,
            company_licenses: this.getOptLic(value.data.license_ids)
        });
    };

    setTypeValue = value => {
        const max_pdl = this.state.inst_types.filter(o => o.id === value)[0]
            .max_pdl;
        this.getOptTypes(value);
        this.setState({ activitySelectDisabled: false, max_pdl: max_pdl });
    };

    renderDisabledCustomerSelect() {
        return (
            <div style={{ display: "inline" }}>
                <br />
                <aor.SelectInput
                    name="customer_id"
                    disabled={this.state.customerSelectDisabled}
                    style={{ width: "100%" }}
                    label={"Clienti"}
                />
            </div>
        );
    }

    renderCustomerSelect() {
        return !this.state.customerSelectDisabled ? (
            <div>
                <br />
                <Field
                    disabled={this.state.customerSelectDisabled}
                    validate={aor.required()}
                    name="customer_id"
                    component={AutoCompleteInput}
                    {...{
                        options: customerOptions,
                        lazy: false,
                        filter: {
                            company_name: this.state.company
                                ? this.state.company
                                : ""
                        }
                    }}
                />
            </div>
        ) : (
            this.renderDisabledCustomerSelect()
        );
    }

    renderDisabledActivitySelect() {
        return (
            <div style={{ display: "inline" }}>
                <br />
                <aor.SelectInput
                    source="activity"
                    disabled={this.state.activitySelectDisabled}
                    style={{ width: "100%" }}
                    label={"Attività"}
                />
            </div>
        );
    }

    renderActivitySelect() {
        return !this.state.activitySelectDisabled ? (
            <aor.SelectInput
                source="activity"
                label="resources.tickets.fields.activity"
                choices={this.state.activity_types}
                validate={aor.required()}
                disabled={this.state.activitySelectDisabled}
                defaultValue={""}
                style={{ width: "100%" }}
                onChange={(id, name) => this.setState({ activityType: name })}
            />
        ) : (
            this.renderDisabledActivitySelect()
        );
    }

    renderDisabledInstallationTypeSelect() {
        return (
            <div style={{ display: "inline" }}>
                <br />
                <aor.SelectInput
                    source="installation_type_id"
                    disabled={this.state.instTypeSelectDisabled}
                    style={{ width: "100%" }}
                    label={"Tipo"}
                />
            </div>
        );
    }

    renderInstallationTypeSelect() {
        return !this.state.instTypeSelectDisabled ? (
            <aor.SelectInput
                source="installation_type_id"
                label="resources.installations.fields.installation_type_id"
                choices={this.state.company_licenses}
                validate={aor.required()}
                disabled={this.state.instTypeSelectDisabled}
                defaultValue={""}
                style={{ width: "100%" }}
                onChange={(id, name) => this.setTypeValue(name)}
            />
        ) : (
            this.renderDisabledInstallationTypeSelect()
        );
    }

    renderMaxPdlNumberInput() {
        let arrayValidator = [aor.required(), aor.number(), aor.minValue(1)];
        if (this.state.max_pdl) {
            arrayValidator = [
                aor.required(),
                aor.number(),
                aor.minValue(1),
                aor.maxValue(this.state.max_pdl)
            ];
        }
        return (
            <aor.NumberInput
                source="pdl"
                label="resources.tickets.fields.pdl"
                validate={arrayValidator}
                inputProps={{
                    min: 1
                }}
                defaultValue={1}
            />
        );
    }

    render() {
        return (
            <div>
                {(getPolicies().includes(POLICY_TICKETS.CREATE) && (
                    <div>
                        <Field
                            validate={aor.required()}
                            name="company_id"
                            component={AutoCompleteInput}
                            {...{
                                options: companyOptions,
                                callBack: this.setCompanyValue
                            }}
                        />
                    </div>
                )) ||
                    (getPolicies().includes(POLICY_TICKETS.SAFE_CREATE) && (
                        <div>
                            <aor.SelectInput
                                defaultValue={parseInt(company_id, 10)}
                                source="company_id"
                                choices={[
                                    {
                                        id: parseInt(company_id, 10),
                                        name: this.state.loginCompanyName
                                    }
                                ]}
                                disabled={true}
                                label={"resources.companies.nameSingular"}
                            />
                        </div>
                    ))}
                {this.renderCustomerSelect()}
                {this.renderInstallationTypeSelect()}
                {this.renderActivitySelect()}
                {this.state.activityType === "INSTALLATION" &&
                    this.renderMaxPdlNumberInput()}
            </div>
        );
    }
}

export default TicketCreate;



// WEBPACK FOOTER //
// ./src/components/TicketCreate.js